// extracted by mini-css-extract-plugin
export default {"root":"sidebar_root__URUEJ","item":"sidebar_item__7cNqR","sidebarDark":"sidebar_sidebarDark__pYRXj","control":"sidebar_control__lIpT6","chevron":"sidebar_chevron__tZ2a5"};